import React from 'react';

const ErrorStatusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={35}
    height={35}
    viewBox="0 0 350 350"
  >
    <path
      d="M330.374 329.009H15.837c-7.127 0-13.502-3.684-17.066-9.853-3.563-6.17-3.563-13.534 0-19.703l157.27-272.397c3.562-6.17 9.942-9.854 17.065-9.854 7.126 0 13.502 3.684 17.061 9.854l157.269 272.397c3.563 6.17 3.563 13.533.004 19.703-3.56 6.17-9.94 9.853-17.066 9.853zM173.106 28.872a7.96 7.96 0 00-6.964 4.019L8.878 305.284a7.956 7.956 0 000 8.033c1.454 2.517 4.053 4.018 6.959 4.018h314.537c2.906 0 5.509-1.505 6.96-4.018s1.45-5.52 0-8.033L180.064 32.89c-1.45-2.517-4.053-4.019-6.958-4.019zm0 262.198c-15.969 0-28.965-12.993-28.965-28.961s12.992-28.961 28.965-28.961 28.96 12.992 28.96 28.96-12.988 28.962-28.96 28.962zm0-46.252c-9.535 0-17.295 7.756-17.295 17.29s7.76 17.292 17.295 17.292 17.29-7.757 17.29-17.291-7.756-17.291-17.29-17.291zm0-24.465c-14.76 0-26.771-12.008-26.771-26.77v-62.797c0-14.758 12.008-26.77 26.77-26.77 14.76 0 26.768 12.008 26.768 26.77v62.8c0 14.763-12.009 26.767-26.767 26.767zm0-104.668c-8.329 0-15.101 6.773-15.101 15.101v62.8c0 8.329 6.772 15.101 15.1 15.101 8.325 0 15.098-6.772 15.098-15.1v-62.8c0-8.33-6.773-15.102-15.097-15.102z"
      fill="#fff"
      strokeMiterlimit={10}
    />
  </svg>
);

export default ErrorStatusIcon;
